function pixel(n) {
    return Math.round(n);
}
/** left/top + x/y alias (sunucu properties ile uyumlu). */
function positionPatchRecord(obj) {
    const x = pixel(obj.x);
    const y = pixel(obj.y);
    return { left: x, top: y, x, y };
}
/** Sunucu `properties` JSON'u (timeline / defaultState) ile uyumlu layout alanları. */
export function sceneObjectToLayoutPropertiesJson(obj) {
    return JSON.stringify({
        ...positionPatchRecord(obj),
        width: pixel(obj.width),
        height: pixel(obj.height),
        rotation: obj.rotation,
        opacity: obj.opacity,
    });
}
/** DB jsonb || patch — sürükleme: sadece konum (positionPatchRecord). */
export function sceneObjectDragPositionPatchJson(obj) {
    return JSON.stringify(positionPatchRecord(obj));
}
/** DB jsonb || patch — resize sonrası: konum + boyut + rotation + opacity. */
export function sceneObjectTransformPatchJson(obj) {
    return JSON.stringify({
        ...positionPatchRecord(obj),
        width: pixel(obj.width),
        height: pixel(obj.height),
        rotation: obj.rotation,
        opacity: obj.opacity,
    });
}
/** Keyframe state’ini başka bir keyframe satırına yazmak için jsonb patch. */
export function keyframeStatePatchJson(state) {
    const x = pixel(state.x);
    const y = pixel(state.y);
    return JSON.stringify({
        left: x,
        top: y,
        x,
        y,
        width: pixel(state.width),
        height: pixel(state.height),
        rotation: state.rotation,
        opacity: state.opacity,
        ...(state.scaleX != null ? { scaleX: state.scaleX } : {}),
        ...(state.scaleY != null ? { scaleY: state.scaleY } : {}),
    });
}
